"use strict";

import CRender from './CRender';
import CInputManager from './CInputManager';

export default class CChart{

    constructor(canvas,type, eventBus){
        this._render=new CRender(canvas);
        this._inputManager=new CInputManager(canvas);
        this._type=type;
        this._type.setWidth(this._render.getWidth());
        this._type.setHeight(this._render.getHeight());
        this.eventBus = eventBus;
        // this._type.setHeight(300);
        this._type.setInputManager(this._inputManager);
        this.resizeCallback = () => {
            setTimeout(() => {
                this.render();
            }, 2000);
        };

        window.addEventListener('resize', this.resizeCallback);
        this.eventBus.$on('Dashboard:toggleMenu', this.resizeCallback);
    }

    setData(data){
        this._type.setElements(data);
    }

    setConfig(config){
        this._type.setConfig(config);
    }

    render(){
        this._inputManager.clear();
        this._render.update(this._type.getElements());
    }

    clear() {
        this._inputManager.clear();
        this._render.clear();
        window.removeEventListener('resize', this.resizeCallback);
        this.eventBus.$off('Dashboard:toggleMenu');
    }
}




// WEBPACK FOOTER //
// ./src/components/cchart/CChart.js